import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/pc/');
export default function Section2() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();

    const web1Map: any = {
        us: ['DETALPRO_web1/DETAL PRO_web_1.webp', 'DETALPRO_web1/DETAL PRO_web_1.png'],
        au: ['DETALPRO_web1/DETAL PRO_web_1_au.webp', 'DETALPRO_web1/DETAL PRO_web_1_au.png'],
        jp: ['DETALPRO_web1/DETAL PRO_web_1_jp.webp', 'DETALPRO_web1/DETAL PRO_web_1_jp.png'],
        uk: ['DETALPRO_web1/DETAL PRO_web_1_uk.webp', 'DETALPRO_web1/DETAL PRO_web_1_uk.png'],
        de: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        fr: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        eu: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        it: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        es: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        kr: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        cis: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        cn: ['DETALPRO_web1/DETAL PRO_web_1_cn.webp', 'DETALPRO_web1/DETAL PRO_web_1_cn.png'],
        za: ['DETALPRO_web1/DETAL PRO_web_1_za.webp', 'DETALPRO_web1/DETAL PRO_web_1_za.png'],
        sa: ['DETALPRO_web1/DETAL PRO_web_1_uk.webp', 'DETALPRO_web1/DETAL PRO_web_1_uk.png'],
    };

    return (
        <div
            className={`${css.section03} GtmModuleData-section`}
            data-section-id={css.section03}
            data-section-title={t('second_capacity_value') + t('second_capacity')}
        >
            <div className="top">
                <div className="tl">
                    <div className="tlt box">
                        <EFPic name={['DETAL PRO_web_2.webp', 'DETAL PRO_web_2.png']} alt={t('second_ac_onput')} aria-label={t('second_ac_onput')} />
                        <p className="tit">
                            {t('second_ac_onput_value')}
                            <br />
                            {t('second_ac_onput')}
                        </p>
                    </div>
                    <div className="tlb box">
                        <EFPic
                            name={['DETAL PRO_web_5.webp', 'DETAL PRO_web_5.png']}
                            alt={t('second_ev_station_charging')}
                            aria-label={t('second_ev_station_charging')}
                        />
                        <p className="tit">{t('second_ev_station_charging')}</p>
                    </div>
                </div>
                <div className="tm box">
                    <EFPic name={web1Map[locale] || web1Map['us']} alt={t('second_capacity_value')} aria-label={t('second_capacity_value')} />
                    <p className="tit">
                        {t('second_capacity_value')}
                        <br />
                        {t('second_capacity')}
                    </p>
                </div>
                <div className="tr box">
                    <EFPic
                        name={['DETAL PRO_web_6.webp', 'DETAL PRO_web_6.png']}
                        alt={t('second_expandable_ecosystem')}
                        aria-label={t('second_expandable_ecosystem')}
                    />
                    <p className="tit">{t('second_expandable_ecosystem')}</p>
                </div>
            </div>
            <div className="bottom">
                <div className="bl box">
                    <EFPic name={['DETAL PRO_web_3.webp', 'DETAL PRO_web_3.png']} alt={t.raw('second_flow_charge')} aria-label={t.raw('second_flow_charge')} />
                    <p className="tit" dangerouslySetInnerHTML={{ __html: t.raw('second_flow_charge') }}></p>
                </div>
                <div className="bm box">
                    <EFPic name={['DETAL PRO_web_4.webp', 'DETAL PRO_web_4.png']} alt={t('second_multicharge')} aria-label={t('second_multicharge')} />
                    <p className="tit">
                        {t('second_multicharge_value')}
                        <br />
                        {t('second_multicharge')}
                    </p>
                </div>
                <div className="br">
                    <div className="brt box">
                        <p className="tit">{t('second_solar_input_no_html')}</p>
                    </div>
                    <div className="brb box">
                        <p className="tit">{t('second_lfp_battery_chemistry')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
